module.exports = {
      id: "prothomalo-trust-usage",
      viewBox: "0 0 260 65",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#prothomalo-trust",
      toString: function () {
        return this.url;
      }
    }